import * as React from "react";
import Box from "@mui/material/Box";
import { Button, Modal } from "@mui/material";
import useStyles from "../../../../../Create/Event/ViewBuyerLots/ViewBuyer/viewBuyer.style";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import EditBuyerTable from "../../../../../../commonComponents/EditBuyerTable";
import { RiInboxArchiveLine } from "react-icons/ri";
import getViewByBuyerList from "../../../../../../../api/getViewByBuyerList";
import { useNavigate } from "react-router-dom";
import routes from "../../../../../../../constants/routes";
import { ButtonGroup } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";

export default function EditViewBuyer(eventEditId) {
  // const eventId = location.state.data.eventId;
  const classes = useStyles();
  const eventId = eventEditId.eventEditId.eventEditId;
  const navigate = useNavigate();

  const [selectedRows, setSelectedRows] = useState([]);
  const [clearSelectedRows, updateClearSelectedRows] = useState(false);
  const [buyerLotsModal, toggleBuyerLotsModal] = useState(false);
  const [tableEventsData, setTableEventsData] = useState([]);
  const rows = null;

  const [loading, setLoading] = useState(true);

  const [columnsEventBuyers, setColumnsEventBuyers] = useState([
    {
      name: "Buyer Name",
      selector: (data) => String(data.name || ""),
      cell: (data) => String(data.name),
      sortable: true,
    },
    {
      name: "Buyer Email",
      selector: (data) => String(data.email || ""),
      cell: (data) => String(data.email),
      sortable: true,
    },
    {
      name: "Contact No.",
      selector: (data) => String(data.contactNumber || ""),
      cell: (data) => String(data.contactNumber),
      sortable: true,
    },
    {
      name: "Alt. Contact No.",
      selector: (data) => String(data.alternateContactNumber || ""),
      cell: (data) => String(data.alternateContactNumber),
      sortable: true,
    },
    {
      name: "Allotted Lots",
      minWidth: "140px",
      selector: (data) => Number(data.totalLots) || 0,
      cell: (data) => (
        <div>
          <RiInboxArchiveLine className={classes.lots} />{" "}
          {String(data.totalLots)}
        </div>
      ),
      sortable: true,
      export: false,
    },
    {
      name: "Due Lots",
      selector: (data) => Number(data.dueLots) || 0,
      cell: (data) => String(data.dueLots ?? 0),
      sortable: true,
    },
  ]);

  const eventBuyersList = async () => {
    try {
      const payload = { auctionId: eventId };
      const dataEventBuyers = await getViewByBuyerList(payload);

      if (dataEventBuyers) {
        const eventsBuyerList = dataEventBuyers.data.map((data) => {
          return {
            name: `${data.user.firstName} ${data.user.lastName}`,
            email: data.user.email,
            contactNumber: data.user.contactNumber,
            alternateContactNumber: data.user.alternateContactNumber,
            eventBuyerId: data.eventBuyerId,
            totalLots: data.totalLots,
            dueLots: data.dueLots,
          };
        });
        setTableEventsData(eventsBuyerList);
      } else throw new Error(dataEventBuyers);
    } catch (error) {
      console.log(error);
    }
  };
  React.useEffect(() => {
    setTimeout(() => {
      console.log("useEffect called");
      eventBuyersList();
    }, 1000);

    return () => {
      return false;
    };
  }, [eventId]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    //   border: "1px solid #989898",
    boxShadow: "none",
    p: 4,
  };

  const [modalOpen, setModalOpen] = useState({});
  const handleOpen = (text) => {
    setModalOpen(
      {
        visible: true,
        type: text,
      },
      console.log("handleOpen called")
    );
  };
  // The DataTable keeps its own copy of the selection and only resets it when
  // the clearSelectedRows prop changes value. Emptying selectedRows on its own
  // leaves that internal copy behind, and the stale buyer then rides along in
  // the next add/remove payload.
  const clearTableSelection = () => {
    setSelectedRows([]);
    updateClearSelectedRows((previous) => !previous);
  };

  const handleClose = (text) => {
    setModalOpen({
      visible: false,
      type: text,
    });
    setTimeout(() => {
      eventBuyersList();
    }, 1000);
  };

  return (
    <div className="editviewBuyer">
      <Box sx={{ width: "100%", padding: "0px !important" }}>
        {selectedRows.length > 0 && (
          <div
            className="email-container"
            style={{
              background: "#2D55EB",
              paddingTop: "10px",
              height: "55px",
            }}
          >
            <Button
              type="primary"
              className="addlots"
              onClick={() => {
                handleOpen("Add");
              }}
            >
              Add Lots
            </Button>
            <Button
              type="primary"
              className="addlots"
              sx={{ color: "red !important" }}
              onClick={() => {
                handleOpen("Remove");
              }}
            >
              Remove Lots
            </Button>
          </div>
        )}

        <div>{JSON.stringify()}</div>
        <DataTableExtensions
          print={false}
          export={false}
          exportHeaders={true}
          columns={columnsEventBuyers}
          data={tableEventsData}
          checkboxSelection
          // checkboxSelection={false}
        >
          <DataTable
            noHeader
            keyField="eventBuyerId"
            defaultSortField="id"
            defaultSortAsc={true}
            pagination
            highlightOnHover
            export={false}
            exportHeaders={false}
            selectableRows={true}
            onSelectedRowsChange={(data) => {
              setSelectedRows(data.selectedRows);
            }}
            clearSelectedRows={clearSelectedRows}
            className="DataTable"
          />
        </DataTableExtensions>

        {/* <Button
        className={classes.next}
        onClick={() => {
          navigate(routes.dashboard);
        }}
      >
        Go To Dashboard
      </Button> */}
        <Button
          className={classes.next}
          onClick={() => {
            navigate(routes.dashboard);
          }}
        >
          Go To Dashboard
        </Button>
        <Modal
          open={modalOpen.visible}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box sx={{ textAlign: "right" }}>
              <Button
                className="hoverClose"
                onClick={handleClose}
                sx={{
                  backgroundColor: "rgb(45, 85, 235)",
                  color: "#fff",
                  marginBottom: "1em",
                }}
              >
                <CloseIcon />
              </Button>
            </Box>
            <EditBuyerTable
              type={modalOpen.type}
              modalHandleClose={handleClose}
              eventBuyersList={eventBuyersList}
              data={[...selectedRows]}
              eventId={eventId}
              clearTableSelection={clearTableSelection}
            />
          </Box>
        </Modal>
      </Box>
    </div>
  );
}
